import React, { Component } from "react";
import { SecondaryFormNav } from "../../components/SecondaryFormNav";
class ApplicationDeclined extends Component {
  state = {
    heading: null,
    showProgressBar: false,
    pageId: "application-declined"
  };
  componentWillMount = () => {
    const stepData = this.props.stepData;

    if (!(this.props.declined || this.props.minorDeclined)) {
      this.props.history.push("/");
    } else {
      this.props.setHeaderDisplay(
        this.state.heading,
        stepData.displayStep,
        this.state.showProgressBar,
        this.state.pageId,
        stepData.step
      );
    }
  };
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  handlePrevious = () => {
    const stepData = this.props.stepData;
    this.props.previousStep(stepData);
  };
  handlePrimaryClick = () => {
    const stepData = this.props.stepData;
    this.props.nextStep(stepData);
  };
  handleSecondaryClick = () => {
    const stepData = this.props.stepData;
    stepData.altBack = true;
    this.props.previousStep(stepData);
  };
  backToForm = () => {
    this.props.history.goBack();
  };
  handleSubmit = fields => {
    const isErr = this.props.validateStep(fields);
    const stepData = this.props.stepData;

    if (!isErr) {
      this.props.nextStep(stepData);
    }
  };
  render() {
    const declined = this.props.declined;
    return (
      <div className="col-19">
        <h2>
          <img src="/images/icons/declined.svg" aria-hidden="true" alt="" />
          &nbsp;Application Declined
        </h2>
        {declined ? (
          <div>
            <p className="description">
              We are unable to move forward with your visitation application
              based your answers in the Visitor Questionnaire. Please refer to
              Operating Procedure 851.1 for more details on our visitation
              policies.
            </p>
            <a
              href="https://vadoc.virginia.gov/families-and-friends/visitation"
              className="primary-button"
            >
              Return to Visitation
            </a>
          </div>
        ) : (
          <div>
            <p className="description">
              We’re unable to move forward with your request to add this minor
              to your visitation application based your answers in the Minor
              Visitor Questionnaire. Please refer to Operating Procedure 851.1
              for more details on our visitation policies.
            </p>
            <form className="visitation-form clear-fix">
              <SecondaryFormNav
                primaryLabel="Continue without adding this minor"
                handlePrimaryClick={this.handlePrimaryClick}
                secondaryLabel="Add a different Minor"
                handleSecondaryClick={this.handleSecondaryClick}
              />
            </form>
          </div>
        )}
      </div>
    );
  }
}

export default ApplicationDeclined;



// WEBPACK FOOTER //
// ./src/pages/ApplicationDeclined/ApplicationDeclined.js